import React from 'react'
import styled from 'styled-components'
import { graphql, compose } from 'react-apollo'
import SignatureRequestStatus from './../queries/SignatureRequestStatus'
import Loader from './../../common/Loader'
import FadeInUpWrapper from '../../common/FadeInUpWrapper'


const StatusTable = styled.table`
  width: 100%;
  text-align: left;
  thead {
    background-color: #75AFB6;
    color: white;
  }
  td {
    padding: 8px;
  }
  tr {
    border-bottom: 1px solid #9B9B9B;
  }
`
const Header = styled.div`
 height: 40px;
 display: flex;
 width: 100%;
 box-sizing: border-box;
 justify-content: flex-end;
 padding: 10px;
 a {
   color: inherit;
   &:hover { cursor: pointer; }
 }
 span {
    text-align: center;
    flex: 1;
 }
`
const Body = styled(FadeInUpWrapper)`
  font-size: 16px;
  width: 650px;
  background: white;
  box-sizing: border-box;
  box-shadow: 0 4px 10px -2px rgba(0,0,0,0.3);
`

class SignatureRequestStatusModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      esignStatus: []
    }
    this.getEsignStatus()
  }
  getEsignStatus = async () => {
    try {
      const { data: { signatureRequestStatus: { helloSignSignatures } } } = await this.props.signatureRequestStatus({
        variables: {
          input: {
            documentId: this.props.document.rid
          }
        }
      })
      this.setState({
        esignStatus: helloSignSignatures
      })
    } catch (err) {
      console.log(err)
    }
  }

  renderStatusTable = () => {
    if (this.state.esignStatus.length === 0) {
      return <Loader number={5} />
    }
    const view = this.state.esignStatus.map(s => {
      let status
      if (s.signed) {
        status = 'Completed'
      } else if (s.viewed) {
        status = 'Viewed'
      } else {
        status = 'Sent'
      }
      return (
        <tr key={s.name}>
          <td>{s.name}</td>
          <td>{s.email}</td>
          <td>{status}</td>
        </tr>
      )
    })
    return (
      <StatusTable>
        <thead>
          <tr>
            <td> Signer </td>
            <td> Email </td>
            <td> Status </td>
          </tr>
        </thead>
        <tbody>
          {view}
        </tbody>
      </StatusTable>
    )
  }
  render() {
    const { toggleModal } = this.props
    return (
      <Body id="signature_request_status_modal">
        <Header>
          <span>E-Sign Status</span>
          <a id="close_signature_request_status_modal" onClick={toggleModal}>X</a>
        </Header>
        { this.renderStatusTable() }
      </Body>
    )
  }
}
const SignatureRequestStatusModalWithQuery = compose(
  graphql(SignatureRequestStatus, {
    name: 'signatureRequestStatus'
  }),
)(SignatureRequestStatusModal)

export default SignatureRequestStatusModalWithQuery
